import { ROLE_ASSETS_ENDPOINT } from '../service/backend_endpoints/_endpointPaths'
import { apiService } from '../service/api.service'
const GET_ROLE_ASSETS = 'getRoleAsssets'

const state = {
  roleAssets: [],
  loadingRoleAssets: true
}

const getters = {
  getRoleAsssets: state => state.roleAssets,
  loadingRoleAssets (state) {
    return state.loadingRoleAssets
  }
}

const actions = {
  async [GET_ROLE_ASSETS] (context) {
    context.commit('setRoleAssetsLoading', true)
    try {
      const { data } = await apiService.get(ROLE_ASSETS_ENDPOINT)
      context.commit(GET_ROLE_ASSETS, data)
    } catch (error) {
      throw error.response
    } finally {
      context.commit('setRoleAssetsLoading', false)
    }
  }
}

const mutations = {
  [GET_ROLE_ASSETS] (state, payload) {
    state.roleAssets = payload.data
  },
  setRoleAssetsLoading (state, payload) {
    state.loadingRoleAssets = payload
  }

}

export default {
  state,
  actions,
  mutations,
  getters
}
